module.exports = __webpack_public_path__ + "img/share_error_1.49c4d1be.svg";